import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/api';

const ROLES = {
    EMPLOYEE: 'EMPLOYEE',
    HR: 'HR',
    MANAGER: 'MANAGER',
  };

function AddEmployee() {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [employeeData, setEmployeeData] = useState({
  role: ROLES.EMPLOYEE, // better if reusing constants
  
});
  const [managers, setManagers] = useState([]);
   const[departments,setDepartments]= useState([]);

  

  const fetchManagers = async () => {
      try {
        const res = await api.get(`/auth/managers`);
        setManagers(res.data);
      } catch (err) {
        console.error("Failed to fetch managers", err);
      }
    };


     const fetchDepartments = async () => {
      try {
        const res = await api.get(`/api/departments/all`);
        setDepartments(res.data);
      } catch (err) {
        console.error("Failed to fetch managers", err);
      }
    };

    useEffect(() => {
    
    fetchDepartments();
    fetchManagers();
    }, [baseUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`/auth/employee`, employeeData);
      if (response.status === 201 || response.status === 200) {
        toast.success('Employee added successfully');
        navigate(-1);
      }
    } catch (error) {
      console.error('Error adding employee:', error);
      toast.error('Failed to add employee');
    }
  };

  return (
    <div className='w-full h-full px-4 sm:px-6 pb-20'>
      <div className='py-4 sm:py-6'>
        <h2 className='text-xl sm:text-2xl font-bold text-slate-800'>Add new employee</h2>
      </div>
   
      <form className='flex flex-col w-full bg-white shadow-lg rounded-xl p-6 space-y-6' 
      onSubmit={handleSubmit}>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
          {/* First Column */}
          <div className='space-y-6'>
            <div className="space-y-2">
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 pl-2">
                Full Name
              </label>
              <input
                type="text"
                name="fullName"
                id="fullName"
                value={employeeData.name || ''}
                onChange={(e) => setEmployeeData({...employeeData, name: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="employeeId" className="block text-sm font-medium text-gray-700 pl-2">Employee ID</label>
              <input
                type="text"
                name="employeeId"
                id="employeeId"
                value={employeeData.employeeId || ''}
                onChange={(e) => setEmployeeData({...employeeData, employeeId: e.target.value})}
                className='pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="location" className="block text-sm font-medium text-gray-700 pl-2">Base Location</label>
              <input
                type="text"
                name="location"
                id="location"
                value={employeeData.location || ''}
                onChange={(e) => setEmployeeData({...employeeData, location: e.target.value})}
   className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="designation" className="block text-sm font-medium text-gray-700 pl-2">Designation</label>
              <input
                type="text"
                name="designation"
                id="designation"
                value={employeeData.designation || ''}
                onChange={(e) => setEmployeeData({...employeeData, designation: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700 pl-2">
                Contact Number
              </label>
              <input
                type="tel"
                name="contactNumber"
                id="contactNumber"
                value={employeeData.contactNumber || ''}
                onChange={(e) => setEmployeeData({...employeeData, contactNumber: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

             <div className="space-y-2">
      <label htmlFor="reportingManager" className="block text-sm font-medium text-gray-700 pl-2">
        Reporting Manager
      </label>
      <select
        name="reportingManager"
        id="reportingManager"
        value={employeeData.reportingManager || ''}
        onChange={(e) =>
          setEmployeeData({ ...employeeData, reportingManager: e.target.value })
        }
        className="pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300"
      >
        <option value="">None</option>
        {managers.map((manager) => (
          <option key={manager.id} value={manager.name}>
            {manager.name}
          </option>
        ))}
      </select>
    </div>

    <div className="space-y-2">
      <label htmlFor="department" className="block text-sm font-medium text-gray-700 pl-2">
         Department
      </label>
      <select
        name="department"
        id="department"
        value={employeeData.department || ''}
        onChange={(e) =>
          setEmployeeData({ ...employeeData, department: e.target.value })
        }
        className="pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300"
      >
        <option value="">None</option>
        {departments.map((department) => (
          <option key={department.id} value={department.departmentName}>
            {department.departmentName}
          </option>
        ))}
      </select>
    </div>
          </div>

          {/* Second Column */}
          <div className='space-y-6'>
            <div className="space-y-2">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 pl-2">Email ID</label>
              <input
                type="email"
                name="email"
                id="email"
                value={employeeData.email || ''}
                onChange={(e) => setEmployeeData({...employeeData, email: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="bankName" className="block text-sm font-medium text-gray-700 pl-2">Bank Name</label>
              <input
                type="text"
                name="bankName"
                id="bankName"
                value={employeeData.bankName || ''}
                onChange={(e) => setEmployeeData({...employeeData, bankName: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700 pl-2">Account Number</label>
              <input
                type="text"
                name="accountNumber"
                id="accountNumber"
                value={employeeData.accountNumber || ''}
                onChange={(e) => setEmployeeData({...employeeData, accountNumber: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="ifscCode" className="block text-sm font-medium text-gray-700 pl-2">IFSC Code</label>
              <input
                type="text"
                name="ifscCode"
                id="ifscCode"
                value={employeeData.ifsccode || ''}
                onChange={(e) => setEmployeeData({...employeeData, ifsccode: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="emergencyContact" className="block text-sm font-medium text-gray-700 pl-2">
                Emergency Contact Number
              </label>
              <input
                type="tel"
                name="emergencyContact"
                id="emergencyContact"
                value={employeeData.emergencyContactNumber || ''}
                onChange={(e) => setEmployeeData({...employeeData, emergencyContactNumber: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="costCenter" className="block text-sm font-medium text-gray-700 pl-2">
                Cost Center
              </label>
              <input
                type="text"
                name="costCenter"
                id="costCenter"
                value={employeeData.costCenter || ''}
                onChange={(e) => setEmployeeData({...employeeData, costCenter: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

             <div className="space-y-2">
      <label htmlFor="office" className="block text-sm font-medium text-gray-700 pl-2">
        Work mode
      </label>
      <select
        name="office"
        id="office"
        value={employeeData.office || ''}
        onChange={(e) =>
          setEmployeeData({ ...employeeData, office: e.target.value })
        }
        className="pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300"
      >
        <option value="IN">In</option>
         <option value="OUT">Out</option>
      </select>
    </div>
          </div>

          {/* Third Column */}
          <div className='space-y-6'>
            <div className="space-y-2">
              <label htmlFor="panNo" className="block text-sm font-medium text-gray-700 pl-2">PAN Number</label>
              <input
                type="text"
                name="panNo"
                id="panNo"
                value={employeeData.panno || ''}
                onChange={(e) => setEmployeeData({...employeeData, panno: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="aadharNo" className="block text-sm font-medium text-gray-700 pl-2">Aadhar Number</label>
              <input
                type="text"
                name="aadharNo"
                id="aadharNo"
                value={employeeData.aadarNo || ''}
                onChange={(e) => setEmployeeData({...employeeData, aadarNo: e.target.value})}
                pattern="[0-9]{12}"
                maxLength={12}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="uanNo" className="block text-sm font-medium text-gray-700 pl-2">UAN Number</label>
              <input
                type="text"
                name="uanNo"
                id="uanNo"
                value={employeeData.uanno || ''}
                onChange={(e) => setEmployeeData({...employeeData, uanno: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="esi" className="block text-sm font-medium text-gray-700 pl-2">ESI Number</label>
              <input
                type="text"
                name="esi"
                id="esi"
                value={employeeData.esino || ''}
                onChange={(e) => setEmployeeData({...employeeData, esino: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="doj" className="block text-sm font-medium text-gray-700 pl-2">Date of Joining</label>
              <input
                type="text"
                name="doj"
                id="doj"
                value={employeeData.doj || ''}
                onChange={(e) => setEmployeeData({...employeeData, doj: e.target.value})}
                className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
              />
            </div>

            <div className="space-y-2">
  <label htmlFor="role" className="block text-sm font-medium text-gray-700 pl-2">
    Role
  </label>
  <select
    name="role"
    id="role"
    value={employeeData.role || ''}
    onChange={(e) => setEmployeeData({...employeeData, role: e.target.value})}
    className=' pl-4 pr-2 py-2.5 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-slate-400 border border-gray-300'
  >
    <option selected value={ROLES.EMPLOYEE}>{ROLES.EMPLOYEE}</option>
    <option value={ROLES.HR}>{ROLES.HR}</option>
    <option value={ROLES.MANAGER}>{ROLES.MANAGER}</option>
  </select>
</div>

            {/* Save Button moved to bottom of third column */}
            <div className="pt-6">
              <button
                type="submit"
                className='w-full bg-slate-800 text-white px-8 py-2.5 
                  rounded-full text-base font-medium hover:bg-slate-700 
                  transition-all duration-200 hover:scale-105 active:scale-95
                  shadow-lg hover:shadow-xl'
              >
                Save Employee
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddEmployee;
